import { isMobile } from 'app/device';
import { QuitWrapper, Scrollable } from 'components';
import {
    GamesWrapper,
    GameWindowMinimized,
    Grid,
    LeadingGame,
} from 'components/games';
import { GameWindowSwiper } from 'components/games/game-window-swiper/GameWindowSwiper';
import { TodaysNotifications } from 'components/notifications/TodaysNotifications';
import { ColumnLayout } from 'components/ui';
import { GlassTitle } from 'components/ui/glass-title/GlassTitle';
import {
    BigTitleWrapper,
    GlassTitleWrapper,
} from 'components/ui/glass-title/GlassTitle.style';
import { If } from 'helpers';
import { useGamesSwiper, useHighLights } from 'hooks';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Games } from 'services';

export function HighLightsScreen() {
    const { highlighted, columns, games } = useHighLights();
    const gamesSwiper = useGamesSwiper(games);
    const glassTitleWrapperRef = useRef();
    const upperElementRef = useRef();
    const gridRef = useRef();
    const { t } = useTranslation();

    return (
        <>
            <TodaysNotifications />
            <QuitWrapper disabled={gamesSwiper.visible} />
            <ColumnLayout alignItems="center" fullSize>
                <If condition={gamesSwiper.visible}>
                    <GameWindowSwiper
                        gamesSwiper={gamesSwiper}
                        selectedIndex={gamesSwiper.selectedIndex}
                        prev={gamesSwiper.prev}
                        next={gamesSwiper.next}
                        games={games}
                    />
                </If>
                <GamesWrapper
                    isGapOpen={gamesSwiper.gapOpen}
                    isDiscoveryOffer={Games.isDiscoveryOffer()}
                >
                    <ColumnLayout fullWidth>
                        <If
                            condition={highlighted && !Games.isDiscoveryOffer()}
                        >
                            <LeadingGame>
                                <BigTitleWrapper>
                                    <If condition={!isMobile}>
                                        <GlassTitleWrapper
                                            ref={glassTitleWrapperRef}
                                            isVisible={!gamesSwiper.visible}
                                        >
                                            <GlassTitle
                                                wrapperRef={
                                                    glassTitleWrapperRef
                                                }
                                            >
                                                {t('navigation.highlights')}
                                            </GlassTitle>
                                        </GlassTitleWrapper>
                                    </If>
                                    <Scrollable
                                        isGapOpen={gamesSwiper.gapOpen}
                                        lastFocused={gamesSwiper.lastFocused}
                                    >
                                        <GameWindowMinimized
                                            ref={upperElementRef}
                                            game={highlighted}
                                            onExpandClicked={gamesSwiper.open}
                                            onQuickMatch={
                                                gamesSwiper.quickMatch
                                            }
                                            gridRef={gridRef}
                                        />
                                    </Scrollable>
                                </BigTitleWrapper>
                            </LeadingGame>
                        </If>
                        <Grid
                            ref={gridRef}
                            isGapOpen={gamesSwiper.gapOpen}
                            lastFocused={gamesSwiper.lastFocused}
                            onItemClicked={gamesSwiper.open}
                            columns={columns}
                            upperElementRef={upperElementRef}
                        />
                    </ColumnLayout>
                </GamesWrapper>
            </ColumnLayout>
        </>
    );
}
